import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationServiceTypeListResponse,
  IConfigurationServiceTypeListResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useConfigurationServiceTypeListAPI = () => {
  const [serviceTypeList, setServiceTypeList] = useState<IConfigurationServiceTypeListResponseData[]>([]);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      await axios
        .get(CONFIGURATION_APIS?.SERVICE_TYPE_LIST?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IConfigurationServiceTypeListResponse>) => {
          if (res.data.status) {
            setServiceTypeList(res.data.data || []);
          } else {
            setServiceTypeList([]);
            toast.error("Error while fetching service types.");
          }
        })
        .catch((e: AxiosError) => {
          setServiceTypeList([]);
          captureError(e);
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      setServiceTypeList([]);
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.code === "ERR_BAD_REQUEST") {
          toast.error("Error at server while fetching service type details.");
        }
        if (axiosError.response?.status === 400) {
          toast.error(axiosError.message);
        }
        if (axiosError.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + (error as Error)?.message);
      }
    }
  }, [configuration, captureError, sendCurl]);

  return { serviceTypeList, execute };
};
